/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinishWorkflow200Response
 */
export interface FinishWorkflow200Response {
    /**
     * 
     * @type {string}
     * @memberof FinishWorkflow200Response
     */
    signupCompletionToken?: string;
}

/**
 * Check if a given object implements the FinishWorkflow200Response interface.
 */
export function instanceOfFinishWorkflow200Response(value: object): value is FinishWorkflow200Response {
    return true;
}

export function FinishWorkflow200ResponseFromJSON(json: any): FinishWorkflow200Response {
    return FinishWorkflow200ResponseFromJSONTyped(json, false);
}

export function FinishWorkflow200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinishWorkflow200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'signupCompletionToken': json['signupCompletionToken'] == null ? undefined : json['signupCompletionToken'],
    };
}

export function FinishWorkflow200ResponseToJSON(value?: FinishWorkflow200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'signupCompletionToken': value['signupCompletionToken'],
    };
}

